import { z } from 'zod';
/** A reference selected by the person, not an attestation that Gmail still
 * holds an unsent message. Private bodies and recipients are not imported. */
export const institutionDraftReferenceSchema = z.object({
    key: z.uuid(),
    programmeId: z.uuid(),
    draftId: z.string().regex(/^[A-Za-z0-9_-]{1,200}$/),
    messageId: z.string().regex(/^[a-fA-F0-9]{1,100}$/),
    threadId: z.string().regex(/^[a-fA-F0-9]{1,100}$/),
    observedAt: z.iso.datetime({ offset: true }),
}).strict().refine(v => Date.parse(v.observedAt) <= Date.now() + 300_000, {
    path: ['observedAt'], message: 'Use the time the draft was observed, not a future plan.',
});
export function institutionDraftReferenceNote(input, mailbox) {
    const v = institutionDraftReferenceSchema.parse(input);
    return {
        key: v.key, programmeId: v.programmeId, kind: 'note',
        occurredAt: v.observedAt, sourceRef: 'gmail-draft:' + v.draftId,
        outcome: 'Prepared Gmail draft reference selected by ' + mailbox +
            '. Observed at ' + v.observedAt + '. Draft ID: ' + v.draftId +
            '; message ID: ' + v.messageId + '; thread ID: ' + v.threadId +
            '. Current provider state is unverified: the draft may since have changed, been deleted or sent. ' +
            'This note records preparation, not completed contact, submission or acceptance. No mail body was imported.',
    };
}
//# sourceMappingURL=institution-drafts.js.map